import { createContext, useContext, useState } from 'react'
import { authApi } from '../api/prospects'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('pe_token'))

  const login = async (email, password) => {
    const res = await authApi.login(email, password)
    localStorage.setItem('pe_token', res.data.access_token)
    setToken(res.data.access_token)
  }

  const logout = () => {
    localStorage.removeItem('pe_token')
    setToken(null)
  }

  return (
    <AuthContext.Provider value={{ token, login, logout, isAuthed: !!token }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
